"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoService = void 0;
const constants_1 = require("../common/constants");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const request_1 = require("../common/request");
const user_info_model_1 = require("./user-info.model");
class UserInfoService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
    }
    isSuperUser() {
        return __awaiter(this, void 0, void 0, function* () {
            let isSuperUser = false;
            // verifico se sono o meno superUser
            const localData5Storage = yield nodejs_library_1.Helpers.SessionHelper.getData(constants_1.Constants.lsMapObject._data5).catch((e) => console.error("Errore nel recupero di dati 5", e));
            if (localData5Storage) {
                const jsonObject = JSON.parse(localData5Storage);
                // tslint:disable-next-line: triple-equals
                if (jsonObject.value0 == "0") {
                    isSuperUser = true;
                }
            }
            return isSuperUser;
        });
    }
    getUserCtx(login) {
        return __awaiter(this, void 0, void 0, function* () {
            if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
                if (nodejs_library_1.Helpers.PageHelper.isHCLAuthoringPage() ||
                    window.location.href.indexOf("/logout?") > -1 ||
                    window.location.href.indexOf("/area_riservata/home-superuser") > -1 ||
                    (window.location.href.indexOf("/accesso?") > -1 && !login)) {
                    return new Promise((resolve, reject) => {
                        resolve(null);
                    });
                }
                else {
                    const nuovaUCC = constants_1.Constants.usoNuovaUCC; //questo booleano comanda se usare la nuova UCC o quella vecchia
                    if (nuovaUCC) {
                        // Versione UCC
                        let isSuperUser = false;
                        // verifico se sono o meno superUser
                        const localData5Storage = yield nodejs_library_1.Helpers.SessionHelper.getData(constants_1.Constants.lsMapObject._data5).catch((e) => console.error("Errore nel recupero di dati 5", e));
                        if (localData5Storage) {
                            const jsonObject = JSON.parse(localData5Storage);
                            // tslint:disable-next-line: triple-equals
                            if (jsonObject.value0 == "0") {
                                isSuperUser = true;
                            }
                        }
                        const su = isSuperUser ? "su/" : "";
                        const requestClienteAnagrafica = new request_1.Request(`contesto-utente/v1/me/${su}cliente/anagrafica`, {}, false, false, "url_priv");
                        return new Promise((resolve, reject) => {
                            this.commonNetworkService
                                .get(requestClienteAnagrafica.completeUrl, requestClienteAnagrafica.headers)
                                .then((datiAnagrafici) => {
                                if (datiAnagrafici) {
                                    this.getRecapiti(su, resolve, datiAnagrafici);
                                }
                                else {
                                    reject(null);
                                }
                            })
                                .catch((err) => {
                                console.error(err);
                                reject(err);
                            });
                        });
                    }
                    else {
                        // Versione prima di UCC
                        const request = new request_1.Request("userContext/v1/users");
                        const ret = this.commonNetworkService.get(request.completeUrl);
                        return new Promise((resolve, reject) => {
                            ret.then((ris) => {
                                const userInfo = new user_info_model_1.UserInfoModel(ris);
                                resolve(userInfo);
                            }, (err) => {
                                reject(err);
                            });
                        });
                    }
                }
            }
            else {
                return new Promise((resolve) => {
                    resolve(null);
                });
            }
        });
    }
    getAnagrafica() {
        return __awaiter(this, void 0, void 0, function* () {
            const isSuperUser = yield this.isSuperUser();
            const su = isSuperUser ? "su/" : "";
            const requestClienteAnagrafica = new request_1.Request(`contesto-utente/v1/me/${su}cliente/anagrafica`, {}, false, false, "url_priv");
            return new Promise((resolve, reject) => {
                this.commonNetworkService.get(requestClienteAnagrafica.completeUrl, requestClienteAnagrafica.headers)
                    .then((datiAnagrafici) => {
                    if (datiAnagrafici) {
                        this.getRecapiti(su, resolve, datiAnagrafici);
                    }
                    else {
                        reject(null);
                    }
                })
                    .catch((err) => {
                    console.error(err);
                    reject(err);
                });
            });
        });
    }
    getRecapiti(su, resolve, datiAnagrafici) {
        const requestRecapiti = new request_1.Request(`contesto-utente/v1/me/${su}recapiti`, {}, false, false, "url_priv");
        this.commonNetworkService.get(requestRecapiti.completeUrl, requestRecapiti.headers)
            .then((recapiti) => {
            this.getUtente(su, resolve, datiAnagrafici, recapiti);
        })
            .catch((err) => {
            this.getUtente(su, resolve, datiAnagrafici, null);
        });
    }
    getUtente(su, resolve, datiAnagrafici, recapiti) {
        const requestUtente = new request_1.Request(`contesto-utente/v1/me/${su}utente`, {}, false, false, "url_priv");
        this.commonNetworkService.get(requestUtente.completeUrl, requestUtente.headers)
            .then((datiUtente) => {
            this.getCliente(su, resolve, datiAnagrafici, recapiti, datiUtente);
        })
            .catch((err) => {
            this.getCliente(su, resolve, datiAnagrafici, recapiti, null);
        });
    }
    getCliente(su, resolve, datiAnagrafici, recapiti, datiUtente) {
        const requestCliente = new request_1.Request(`contesto-utente/v1/me/${su}cliente`, {}, false, false, "url_priv");
        this.commonNetworkService.get(requestCliente.completeUrl, requestCliente.headers)
            .then((datiCliente) => {
            this.getPolizzeCRM(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente);
        })
            .catch((err) => {
            this.getPolizzeCRM(su, resolve, datiAnagrafici, recapiti, datiUtente, null);
        });
    }
    getPolizzeCRM(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente) {
        const requestPolizze = new request_1.Request(`contesto-utente/v2/me/${su}polizze`, {}, false, false, "url_priv");
        this.commonNetworkService.get(requestPolizze.completeUrl, requestPolizze.headers)
            .then((datiPolizze) => {
            this.getPolizzeCollettive(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze);
        })
            .catch((err) => {
            this.getPolizzeCollettive(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, null);
        });
    }
    getPolizzeCollettive(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze) {
        const requestPolizzeCollettive = new request_1.Request(`polizze-collettive/v1/polizze`);
        this.commonNetworkService.get(requestPolizzeCollettive.completeUrl, requestPolizzeCollettive.headers)
            .then((datiPolizzeColletive) => {
            if (datiPolizze) {
                datiPolizze.polizze.push(...datiPolizzeColletive.polizze);
            }
            else {
                datiPolizze = datiPolizzeColletive; // non ci sono polizze crm solo collettive.
            }
            this.getPolizzePrevidenza(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze);
        })
            .catch((err) => {
            this.getPolizzePrevidenza(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze);
        });
    }
    getPolizzePrevidenza(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze) {
        const requestPolizzePrevidenza = new request_1.Request(`polizze-previdenza/v1/previdenza/polizze`);
        this.commonNetworkService.get(requestPolizzePrevidenza.completeUrl, requestPolizzePrevidenza.headers)
            .then((datiPolizzePrevidenza) => __awaiter(this, void 0, void 0, function* () {
            // filtraggio Area IVASS
            let ivassAttivo = null;
            try {
                [ivassAttivo] = yield Promise.all([
                    yield nodejs_library_1.Helpers.SessionHelper.getData("IVASS"),
                ]);
            }
            catch (error) {
                console.error("Errore", error);
            }
            const polizzeFiltrate = datiPolizzePrevidenza.polizze.filter((polizza) => {
                return (!ivassAttivo ||
                    (ivassAttivo &&
                        (polizza.ruoloContraente === "ContraenteFPP" ||
                            polizza.ruoloContraente === "ContraenteRIM")));
            });
            if (datiPolizze) {
                datiPolizze.polizze.push(...polizzeFiltrate);
            }
            else {
                datiPolizze = {
                    polizze: polizzeFiltrate
                }; // non ci sono polizze crm solo collettive.
            }
            this.getTelematici(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze);
        }))
            .catch((err) => {
            this.getTelematici(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze);
        });
    }
    getTelematici(su, resolve, datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze) {
        const requestTelematici = new request_1.Request(`contesto-utente/v2/me/${su}contrattiTelematici`, {}, false, false, "url_priv");
        this.commonNetworkService.get(requestTelematici.completeUrl, requestTelematici.headers)
            .then((datiTelematici) => {
            const userInfo = new user_info_model_1.UserInfoModelNoPartyId(this.buildUserInfo(datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze, datiTelematici));
            resolve(userInfo);
        })
            .catch((err) => {
            console.error(err);
            const userInfo = new user_info_model_1.UserInfoModelNoPartyId(this.buildUserInfo(datiAnagrafici, recapiti, datiUtente, datiCliente, datiPolizze, null));
            resolve(userInfo);
        });
    }
    getRangeDateStoricoPagamenti(useMock = false) {
        const requestRangeDate = new request_1.Request(`tpd/contabilita/polizze/v1/pagamenti/rangeDate`, {}, false, false);
        const rangeDateMock = [
            {
                "label": "2023",
                "parametri": [
                    {
                        "chiave": "dataDa",
                        "valore": "2022-12-31T23:00:00.000Z"
                    },
                    {
                        "chiave": "dataA",
                        "valore": "2023-12-31T22:59:59.000Z"
                    }
                ],
                "anno": "2023-01-01"
            },
            {
                "label": "2022",
                "parametri": [
                    {
                        "chiave": "dataDa",
                        "valore": "2021-12-31T23:00:00.000Z"
                    },
                    {
                        "chiave": "dataA",
                        "valore": "2022-12-31T22:59:59.000Z"
                    }
                ],
                "anno": "2022-01-01"
            }
        ];
        return this.commonNetworkService.get(requestRangeDate.completeUrl, requestRangeDate.headers, false)
            .then((rangeDate) => {
            return useMock ? rangeDateMock : rangeDate;
        }).catch((err) => {
            console.error(err);
            return null;
        });
    }
    getRiepilogoPagamenti(dataDa, dataA, useMock = false) {
        const riepilogoPagamenti = new request_1.Request(`tpd/contabilita/polizze/v1/pagamenti/generaRiepilogo?dataDa=${encodeURIComponent(new Date(dataDa).toISOString())}&dataA=${encodeURIComponent(new Date(dataA).toISOString())}`, {}, false, false);
        const mockResponse = {
            document: "JVBERi0xLjIgDQo5IDAgb2JqDQo8PA0KPj4NCnN0cmVhbQ0KQlQvIDMyIFRmKCAgSGVsbG8gV29ybGQgICApJyBFVA0KZW5kc3RyZWFtDQplbmRvYmoNCjQgMCBvYmoNCjw8DQovVHlwZSAvUGFnZQ0KL1BhcmVudCA1IDAgUg0KL0NvbnRlbnRzIDkgMCBSDQo+Pg0KZW5kb2JqDQo1IDAgb2JqDQo8PA0KL0tpZHMgWzQgMCBSIF0NCi9Db3VudCAxDQovVHlwZSAvUGFnZXMNCi9NZWRpYUJveCBbIDAgMCAyNTAgNTAgXQ0KPj4NCmVuZG9iag0KMyAwIG9iag0KPDwNCi9QYWdlcyA1IDAgUg0KL1R5cGUgL0NhdGFsb2cNCj4+DQplbmRvYmoNCnRyYWlsZXINCjw8DQovUm9vdCAzIDAgUg0KPj4NCiUlRU9G"
        };
        return this.commonNetworkService.get(riepilogoPagamenti.completeUrl, riepilogoPagamenti.headers, true);
    }
    getListaPagamenti(dataDa, dataA, page, size, useMock = false) {
        const mockResponse = [
            {
                "agenzia": "60",
                "dataEffetto": "agiehnecmoghuste",
                "dataPagamento": "cilvidu",
                "dataScadenza": "gakpickiash",
                "descrizioneProdotto": "Zotief ris jabna rejuptis babwujam penagij zoapfob gacutepe puzlago lo weiwe ojo zigosli ufo ekram jemimakuv.",
                "idPolizza": "8084707793174528",
                "polizza": "sadgohlu",
                "polizzaUnica": "cibed",
                "premioTotale": "neewlilwomuf",
                "ramo": "kasu",
                "targa": "hokpuw"
            },
            {
                "agenzia": "46",
                "dataEffetto": "tuprudmakov",
                "dataPagamento": "bemibpuhvefegikh",
                "dataScadenza": "riwolawev",
                "descrizioneProdotto": "Viwsode ifakoloju wu ipaja vo romecbag la pulalmo pas vu za hinosi heig nid ip miw vav votusnel.",
                "idPolizza": "6180759803002880",
                "polizza": "zuhujo",
                "polizzaUnica": "dopk",
                "premioTotale": "votfojdotjovok",
                "ramo": "okiutk",
                "targa": "hewiezoem"
            },
            {
                "agenzia": "63",
                "dataEffetto": "bevsozotgi",
                "dataPagamento": "jevolveelupo",
                "dataScadenza": "kujafalkiegukuis",
                "descrizioneProdotto": "Tullasdi emmujdo kotake kas tianu ih rok voesse ju wap hiktewco hecure biv wapone nojnamupi icpooho.",
                "idPolizza": "6871656679079936",
                "polizza": "ofihehew",
                "polizzaUnica": "elrukawmapubg",
                "premioTotale": "zuraefdororsep",
                "ramo": "komn",
                "targa": "catethopi"
            }
        ];
        const listaPagamenti = new request_1.Request(`tpd/contabilita/polizze/v1/pagamenti?dataDa=${encodeURIComponent(new Date(dataDa).toISOString())}&dataA=${encodeURIComponent(new Date(dataA).toISOString())}&page=${page}&size=${size}`, {}, false, false);
        return this.commonNetworkService.get(listaPagamenti.completeUrl, listaPagamenti.headers, false)
            .then((pagamenti) => {
            return useMock ? mockResponse : {
                pagamenti: pagamenti._embedded.pagamentoModelList,
                page: pagamenti.page
            };
        }).catch((err) => {
            console.error(err);
            return null;
        });
    }
    buildUserInfo(data1, data2, data3, data4, data5, data6) {
        // let recapitiUtente: Recapiti | null = null;
        // let utente: Utente | null = null;
        // let cliente: Cliente | null = null;
        // let polizze: Polizze | null = null;
        // let telematici: TelematicsFromUccV2 | null = null;
        //
        // const anagraficaUtente: Anagrafica =
        //     (typeof data1 === "string" && JSON.parse(data1)) || data1;
        //
        // if (data2)
        //     recapitiUtente =
        //         (typeof data2 === "string" && JSON.parse(data2)) || data2;
        // if (data3)
        //     utente = (typeof data3 === "string" && JSON.parse(data3)) || data3;
        // if (data4)
        //     cliente = (typeof data4 === "string" && JSON.parse(data4)) || data4;
        // if (data5)
        //     polizze = (typeof data5 === "string" && JSON.parse(data5)) || data5;
        // if (data6)
        //     telematici = (typeof data6 === "string" && JSON.parse(data6)) || data6;
        var _a, _b, _c, _d, _e, _f, _g;
        const anagraficaUtente = data1;
        const recapitiUtente = data2;
        const utente = data3;
        const cliente = data4;
        const polizze = data5;
        const telematici = data6;
        let usernameUI = "";
        let partyIdUI = null;
        if (utente) {
            usernameUI = utente.username;
        }
        /* build registry */
        const addressesArray = (_a = anagraficaUtente === null || anagraficaUtente === void 0 ? void 0 : anagraficaUtente.indirizzi) === null || _a === void 0 ? void 0 : _a.map((item) => {
            const address = {
                state: item.stato,
                province: item.provincia,
                cap: item.cap,
                district: item.comune,
                locality: item.localita,
                address: item.indirizzo,
                agencyDescription: item.descAgenzia,
                agencyKey: item.chiaveAgenzia,
                addressType: item.tipoIndirizzo,
                addressId: item.indirizzoId,
            };
            return address;
        });
        let contactInformationsArray;
        if (recapitiUtente)
            contactInformationsArray = (_b = recapitiUtente.recapiti) === null || _b === void 0 ? void 0 : _b.map((item) => {
                var _a, _b, _c, _d, _e;
                const recapito = {
                    function: ((_a = item.origine) === null || _a === void 0 ? void 0 : _a.id)
                        ? (_c = (_b = item.origine) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.toString()
                        : (_d = item.origine) === null || _d === void 0 ? void 0 : _d.id,
                    type: item.tipo ? (_e = item.tipo) === null || _e === void 0 ? void 0 : _e.toString() : item.tipo,
                    value: item.valore,
                    certified: item.certificato,
                };
                return recapito;
            }).filter(function (item) {
                //filtro per recapiti di registrazione id = 1
                return (item === null || item === void 0 ? void 0 : item.function) === "1";
            });
        function removeDuplicates(array, property) {
            return array.filter((obj, pos, arr) => {
                return (arr.map((mapObj) => mapObj[property]).indexOf(obj[property]) === pos);
            });
        }
        const registryUI = {
            optOutSms: anagraficaUtente.optOutSms,
            optOutEmail: anagraficaUtente.optOutEmail,
            contactInformations: contactInformationsArray
                ? removeDuplicates(contactInformationsArray, "type")
                : [],
            addresses: addressesArray,
            agreedCustomer: anagraficaUtente.clienteConvenzionato,
            bankCustomer: anagraficaUtente.clienteBanca,
            commercialPrivacy: anagraficaUtente.privacyCommerciale,
            birthDate: anagraficaUtente.nascitaDt,
            birthLocation: anagraficaUtente.nascitaLuogo,
            gender: anagraficaUtente.sesso,
            taxCodeVAT: anagraficaUtente.cfPiva,
            companyName: anagraficaUtente.ragioneSociale,
            name: anagraficaUtente.nome,
            surname: anagraficaUtente.cognome,
            type: anagraficaUtente.tipo,
            feaAuthorizationFlag: anagraficaUtente.flagAutorizzazioneFea,
            contactInformationsAgencies: [],
        };
        let customerUI = undefined;
        if (cliente) {
            /* build customer */
            customerUI = {
                preactivationDate: cliente.dataPreattivazione,
                name: cliente.nominativo,
                taxCode: utente ? utente.codiceFiscale : "",
                customerPartyId: cliente.partyIdCliente,
                updatedPrivacy: cliente.flagAggiornamentoPrivacy,
                submitTokenCount: cliente.contaInvioToken,
                customerId: cliente.customerId,
            };
        }
        let policiesUI;
        if (polizze === null || polizze === void 0 ? void 0 : polizze.polizze)
            /* build policies */
            policiesUI = (_c = polizze.polizze) === null || _c === void 0 ? void 0 : _c.map((item) => {
                // if(item.sistemaContratto == "CDH" && !item.dscFamiglia) {
                //   item.sistemaContratto = "CRM";
                // }
                if (item.ruoloContraente == "1009" && item.comparto == 1002) {
                    item.sistemaContratto = "CDH_RE";
                }
                const policy = Object.assign({ familyId: item.famigliaId, expirationDate: item.dataScadenza, numberPlate: item.targaVeicolo, inArrears: item.flagArretrato, description: item.sistemaContratto === "CDH"
                        ? `${item.descrizione} - Collettiva`
                        : item.descrizione, 
                    // flagAbilitaSinistro: item.flagAbilitaSinistro,
                    policy: item.polizza, branch: item.ramo, agency: item.agenzia, exdivision: item.exdivisione, company: item.compagnia, division: item.comparto, agreementKey: item.chiaveContratto, agreementSystem: item.sistemaContratto, contractorRole: item.ruoloContraente, segmentValue: item.valoreSegmento, issueDate: item.dataEmissione, subFamilyId: item.sottoFamigliaId, premiumValidityDate: item.dataValiditaPremio
                        ? item.dataValiditaPremio
                        : null, rcaValidityDate: item.dataValiditaRca ? item.dataValiditaRca : null, cvtValidityDate: item.dataValiditaCvt ? item.dataValiditaCvt : null, 
                    // dscFamiglia: item.dscFamiglia,
                    // flagFrazionata: item.flagFrazionata,
                    premioTotaleAnnuoRinnovo: item.premioTotaleAnnuoRinnovo, 
                    // numeroArchivio: item.numeroArchivio,
                    metodoPagamentoAssociatoAttivo: item.metodoPagamentoAssociatoAttivo, metodoPagamentoAssociatoPresente: item.metodoPagamentoAssociatoPresente }, item);
                return policy;
            });
        let contrattiAuto;
        let telematicsUI;
        if (telematici) {
            /* build telematics */
            contrattiAuto = (_e = (_d = telematici.auto) === null || _d === void 0 ? void 0 : _d.contrattiAuto) === null || _e === void 0 ? void 0 : _e.map((item) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                const contrattoAuto = {
                    telematicIdentifier: item.identificativoTelematico,
                    contractType: item.tipoContratto,
                    contractStatus: item.statoContratto,
                    startDate: item.dataInizio,
                    endDate: item.dataFine,
                    telematicDeviceId: item.idTelematicoDispositivo,
                    contactUsers: item.contattiUtenti.map((item) => {
                        const contatto = {
                            contactName: item.nomeContatto,
                            contactPhone: item.telefonoContatto,
                            contactEMail: item.emailContatto,
                        };
                        return contatto;
                    }),
                    vehicle: {
                        type: (_a = item.veicolo) === null || _a === void 0 ? void 0 : _a.tipo,
                        brand: (_b = item.veicolo) === null || _b === void 0 ? void 0 : _b.marca,
                        model: (_c = item.veicolo) === null || _c === void 0 ? void 0 : _c.modello,
                        plate: (_d = item.veicolo) === null || _d === void 0 ? void 0 : _d.targa,
                    },
                    terminalStatus: item.statoTerminale,
                    telematicDevice: {
                        deviceId: (_e = item.dispositivoTelematico) === null || _e === void 0 ? void 0 : _e.idDispositivo,
                        deviceType: (_f = item.dispositivoTelematico) === null || _f === void 0 ? void 0 : _f.tipoDispositivo,
                        deviceOwner: (_g = item.dispositivoTelematico) === null || _g === void 0 ? void 0 : _g.proprietarioDispositivo,
                        imei: (_h = item.dispositivoTelematico) === null || _h === void 0 ? void 0 : _h.imei,
                        deliveryTrackingAvailable: (_j = item.dispositivoTelematico) === null || _j === void 0 ? void 0 : _j.tracciabilitaConsegnaDisponibile,
                    },
                    insuranceContractType: item.tipoContrattoAssicurativo,
                    deleteDataOnContractExpiration: item.datiCancellatiAllaScadenzaDelContratto,
                    contractOwner: item.proprietarioContratto,
                    archiveNumber: item.numeroArchivio ? item.numeroArchivio : 0,
                };
                return contrattoAuto;
            });
            const contrattiImmobili = (_g = (_f = telematici.immobili) === null || _f === void 0 ? void 0 : _f.contrattiImmobili) === null || _g === void 0 ? void 0 : _g.map((item) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30;
                const contrattoImmobile = {
                    companyId: item.idCompagnia,
                    installerRequested: item.installerRichiesto,
                    insuranceContractType: item.tipoContrattoAssicurativo,
                    insuranceContractId: item.idContrattoAssicurativo,
                    telematicIdentifier: item.identificativoTelematico,
                    archiveNumber: item.numeroArchivio ? item.numeroArchivio : "",
                    deviceType: item.tipoDispositivo,
                    buildingProperty: {
                        installationAddress: {
                            floor: (_b = (_a = item.proprietaImmobile) === null || _a === void 0 ? void 0 : _a.indirizzoInstallazione) === null || _b === void 0 ? void 0 : _b.piano,
                            stair: (_d = (_c = item.proprietaImmobile) === null || _c === void 0 ? void 0 : _c.indirizzoInstallazione) === null || _d === void 0 ? void 0 : _d.scala,
                            intern: (_f = (_e = item.proprietaImmobile) === null || _e === void 0 ? void 0 : _e.indirizzoInstallazione) === null || _f === void 0 ? void 0 : _f.interno,
                            extendedAddress: (_h = (_g = item.proprietaImmobile) === null || _g === void 0 ? void 0 : _g.indirizzoInstallazione) === null || _h === void 0 ? void 0 : _h.indirizzoEsteso,
                            postalCode: (_j = item.proprietaImmobile) === null || _j === void 0 ? void 0 : _j.indirizzoInstallazione.codicePostale,
                            town: (_l = (_k = item.proprietaImmobile) === null || _k === void 0 ? void 0 : _k.indirizzoInstallazione) === null || _l === void 0 ? void 0 : _l.citta,
                            province: (_o = (_m = item.proprietaImmobile) === null || _m === void 0 ? void 0 : _m.indirizzoInstallazione) === null || _o === void 0 ? void 0 : _o.provincia,
                            country: (_q = (_p = item.proprietaImmobile) === null || _p === void 0 ? void 0 : _p.indirizzoInstallazione) === null || _q === void 0 ? void 0 : _q.paese,
                        },
                        buildingAddress: {
                            extendedAddress: (_s = (_r = item.proprietaImmobile) === null || _r === void 0 ? void 0 : _r.indirizzoImmobile) === null || _s === void 0 ? void 0 : _s.indirizzoEsteso,
                            postalCode: (_u = (_t = item.proprietaImmobile) === null || _t === void 0 ? void 0 : _t.indirizzoImmobile) === null || _u === void 0 ? void 0 : _u.codicePostale,
                            town: (_w = (_v = item.proprietaImmobile) === null || _v === void 0 ? void 0 : _v.indirizzoImmobile) === null || _w === void 0 ? void 0 : _w.citta,
                            province: (_y = (_x = item.proprietaImmobile) === null || _x === void 0 ? void 0 : _x.indirizzoImmobile) === null || _y === void 0 ? void 0 : _y.provincia,
                            country: (_0 = (_z = item.proprietaImmobile) === null || _z === void 0 ? void 0 : _z.indirizzoImmobile) === null || _0 === void 0 ? void 0 : _0.paese,
                        },
                    },
                    contractor: {
                        company: (_1 = item.contraente) === null || _1 === void 0 ? void 0 : _1.compagnia,
                        surname: (_2 = item.contraente) === null || _2 === void 0 ? void 0 : _2.cognome,
                        name: (_3 = item.contraente) === null || _3 === void 0 ? void 0 : _3.nome,
                        identityId: (_4 = item.contraente) === null || _4 === void 0 ? void 0 : _4.idIdentita,
                        address: {
                            extendedAddress: (_6 = (_5 = item.contraente) === null || _5 === void 0 ? void 0 : _5.indirizzo) === null || _6 === void 0 ? void 0 : _6.indirizzoEsteso,
                            postalCode: (_8 = (_7 = item.contraente) === null || _7 === void 0 ? void 0 : _7.indirizzo) === null || _8 === void 0 ? void 0 : _8.codicePostale,
                            town: (_10 = (_9 = item.contraente) === null || _9 === void 0 ? void 0 : _9.indirizzo) === null || _10 === void 0 ? void 0 : _10.citta,
                            province: (_12 = (_11 = item.contraente) === null || _11 === void 0 ? void 0 : _11.indirizzo) === null || _12 === void 0 ? void 0 : _12.provincia,
                            country: (_14 = (_13 = item.contraente) === null || _13 === void 0 ? void 0 : _13.indirizzo) === null || _14 === void 0 ? void 0 : _14.paese,
                        },
                    },
                    deliverAddress: {
                        careOf: (_15 = item.indirizzoConsegna) === null || _15 === void 0 ? void 0 : _15.inCaricoA,
                        extendedAddress: (_16 = item.indirizzoConsegna) === null || _16 === void 0 ? void 0 : _16.indirizzoEsteso,
                        postalCode: (_17 = item.indirizzoConsegna) === null || _17 === void 0 ? void 0 : _17.codicePostale,
                        town: (_18 = item.indirizzoConsegna) === null || _18 === void 0 ? void 0 : _18.citta,
                        province: (_19 = item.indirizzoConsegna) === null || _19 === void 0 ? void 0 : _19.provincia,
                        country: (_20 = item.indirizzoConsegna) === null || _20 === void 0 ? void 0 : _20.paese,
                    },
                    contactUsers: (_21 = item.contattiUtenti) === null || _21 === void 0 ? void 0 : _21.map((item) => {
                        const contatto = {
                            contactName: item.nomeContatto,
                            contactPhone: item.telefonoContatto,
                        };
                        return contatto;
                    }),
                    feesDetail: {
                        annualFee: (_22 = item.dettaglioTasse) === null || _22 === void 0 ? void 0 : _22.tassaAnnuale,
                        periodFee: (_23 = item.dettaglioTasse) === null || _23 === void 0 ? void 0 : _23.tassaPeriodica,
                        signPeriodFee: (_24 = item.dettaglioTasse) === null || _24 === void 0 ? void 0 : _24.tassaPeriodicaSottoscritta,
                        paymentFrequency: (_25 = item.dettaglioTasse) === null || _25 === void 0 ? void 0 : _25.frequenzaPagamento,
                    },
                    voucherMovementsDetail: {
                        matchKey: (_26 = item.dettaglioMovimentiVoucher) === null || _26 === void 0 ? void 0 : _26.chiaveCorrispondenza,
                        responseKey: (_27 = item.dettaglioMovimentiVoucher) === null || _27 === void 0 ? void 0 : _27.chiaveRisposta,
                        movementCode: (_28 = item.dettaglioMovimentiVoucher) === null || _28 === void 0 ? void 0 : _28.codiceMovimento,
                        idCode: (_29 = item.dettaglioMovimentiVoucher) === null || _29 === void 0 ? void 0 : _29.codiceId,
                    },
                    requestResponseDetail: {
                        requestValidity: (_30 = item.dettaglioRequestResponse) === null || _30 === void 0 ? void 0 : _30.validitaRequest,
                    },
                };
                return contrattoImmobile;
            });
            telematicsUI = {
                auto: {
                    operationResult: {
                        code: null,
                        message: null,
                        type: 0,
                    },
                    contracts: contrattiAuto,
                },
                buildings: {
                    operationResult: {
                        code: null,
                        message: null,
                        type: 0,
                    },
                    contracts: contrattiImmobili,
                },
                pets: {
                    operationResult: {
                        code: null,
                        message: null,
                        type: 0,
                    },
                    contracts: [],
                },
            };
        }
        const userInfo = {
            username: usernameUI,
            registry: registryUI,
            customer: customerUI,
            policies: policiesUI,
            allTelematicContracts: telematicsUI
            // originalTelematics: telematici
        };
        return JSON.stringify(userInfo);
    }
}
exports.UserInfoService = UserInfoService;
